import React, { useState } from 'react';
import '../../Default.css';
import './Quizz.css';
import {initQuiz, initCurrAnswer, colorByCorrectness, NO_ANSWER} from './quizzFunctions';


function Quizz() {

  const [quiz, setQuiz] = useState(initQuiz());

  const [currAnswer, setCurrAnswer] = useState(initCurrAnswer());

  const isLastQuestion = (): boolean => {
    return quiz.currentQuestionIndex + 1 >= quiz.questions.length;
  }

  const handleClickNext = (): void => {
    if (currAnswer.optionIndex === NO_ANSWER) return;

    const currQuestion: number = quiz.currentQuestionIndex;
    
    setQuiz({ 
      ...quiz, 
      answers: [
        ...quiz.answers,
        {
          questionIndex: currQuestion,
          optionIndex: currAnswer.optionIndex
        }
      ],
      currentQuestionIndex: (!isLastQuestion()) ? quiz.currentQuestionIndex + 1 : quiz.currentQuestionIndex,
      isCompleted: (isLastQuestion()) ? true : false,
      score: (quiz.questions[currQuestion].options[currAnswer.optionIndex].isTrue) ? quiz.score + 1 : quiz.score
    });

    if (isLastQuestion()) return;

    currAnswer.ctx.target.checked = false;
    setCurrAnswer({ ...currAnswer, optionIndex: NO_ANSWER})
  }

  const resetQuiz = (): void => {
    setQuiz(initQuiz());
    setCurrAnswer(initCurrAnswer());
  }


  if (quiz.isCompleted)
  {
    return (
      <>
        <div className="page-title">
          Quizz
        </div>
        <div className='quizz-feedback'>
          <div className='text-box-header'>Your result: {quiz.score} / {quiz.questions.length}</div>
          {quiz.answers.map((answer, index) => 
            <div key={index} className='quizz-question'>
              <span>Question #{answer.questionIndex+1}</span>
              <div className='paragraf'>{quiz.questions[answer.questionIndex].question}</div>
              {quiz.questions[answer.questionIndex].options.map((option, index) =>
                <div key={index} className={'quizz-option paragraf '+ colorByCorrectness(option, answer, index)}>{option.answer}</div>
              )}                
            </div>
          )}
          <div className='quizz-quest-navigation'>
            <button type="button" onClick={() => resetQuiz()}>try again</button>
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      <div className="page-title">
        Quizz
      </div>
      <div className='quizz-quest-container'>
        <div className='quizz-question'>
          <span>Question: <b>{quiz.currentQuestionIndex+1} of {quiz.questions.length}</b></span>
          <div className='paragraf'>{quiz.questions[quiz.currentQuestionIndex].question}</div>
          {quiz.questions[quiz.currentQuestionIndex].options.map((option, index) =>
            <div key={index} className='quizz-option paragraf'>
              <input type="radio" id={`${index}`} name="option"
                value={option.answer}
                defaultChecked={false}
                onChange={(e) => { if(e.target.checked === true) setCurrAnswer({ctx:e, optionIndex:index})}}/>
              <label htmlFor={`${index}`}>{option.answer}</label>
            </div>
          )}               
        </div>
        <div className='quizz-quest-navigation'>
          {isLastQuestion()
            ? <button type="button" onClick={() => handleClickNext()}>check</button>
            : <button type="button" onClick={() => handleClickNext()}>next</button>
          }
        </div>
      </div>
    </>
  );
}

export default Quizz;
